<template>
  <div class="table-component p-2">
    <artisio-table selectable ref="sepaTable" :pagination="tableData.pagination" :sort="tableData.ordering"
                   :items="sepas" :checkboxes="false" :fields="fields" :extra-data="extraData"
                   :search="tableData.search" :enable-simple-search="false" :index="false" :busy="loading"
                   export-vuex-module-name="sepas" @paramsChanged="getTableData" requires-min-height>

      <template slot="cell(msg_id)" slot-scope="{item: sepa}">
        {{ sepa.msg_id }}
        <action-buttons
            :view="false"
            :edit="false"
            :remove="sepa.is_latest"
            @deleteClick="onRemoveClick(sepa)"/>
      </template>
      <template slot="cell(created_at)" slot-scope="{item: sepa}">
        {{ sepa.created_at | toDateTime }}
      </template>
      <template slot="cell(created_by)" slot-scope="{item: sepa}">
        {{ sepa.created_by.display_name }}
      </template>
      <template slot="cell(actions)" slot-scope="{item: sepa}">

        <b-dropdown right class="text-white" variant="primary" no-caret size="sm">
          <template #button-content>
            <font-awesome-icon icon="ellipsis-v" class="icon"/>
          </template>

          <b-dd-item @click="download(sepa, 'xml')" >
            <font-awesome-icon icon="file-invoice-dollar" style="font-size: .9em" class="mr-1"/>
            {{ $t('Download XML') }}
          </b-dd-item>

          <b-dd-item @click="download(sepa, 'pdf')">
            <font-awesome-icon icon="file-pdf" style="font-size: .9em" class="mr-1"/>
            {{ $t('Download PDF') }}
          </b-dd-item>

        </b-dropdown>

      </template>
    </artisio-table>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioTable from "@/core/components/ams-table/ArtisioTable";
  import i18n from "../../shared/i18n";
  const {mapState, mapActions} = createNamespacedHelpers('sepa');
  import sepaService from "./SepaService";
  import {SEPA_TABLE_NAME} from "../constants";
  import ActionButtons from "@/core/components/ams-table/ActionButtons.vue";
  const {mapState: globalMapState, mapActions: globalMapActions} = createNamespacedHelpers('global');


  export default {
    name: "SepaTable",
    props: {
      hideActions: {
        type: Array,
        default: () => []
      },
      excludeColumns: {
        type: Array,
        default: () => []
      },
    },
    components: {
      ActionButtons,
      ArtisioTable
    },
    data() {
      return {
        fields: [
          {
            "key": "msg_id",
            "label": i18n.t("Message"),
            "sortable": true,
            "tdClass": "msg-id-no-col",
            "isVisible": true,
            "expand": ""
          },
          {
            "key": "created_at",
            "label": i18n.t("Created At"),
            "sortable": true,
            "tdClass": "created-at-no-col",
            "isVisible": true,
            "expand": ""
          },
          {
            "key": "created_by",
            "label": i18n.t("Created By"),
            "sortable": true,
            "tdClass": "created-by-no-col",
            "isVisible": true,
            "expand": ""
          },
          {
            "key": "actions",
            "label": i18n.t('Actions'),
            "sortable": false,
            "tdClass": "actions-col",
            "isVisible": true,
            "expand": ""
          }
        ]
      }
    },
    computed: {
      ...globalMapState({
        currentUser: state => state.currentUser
      }),
      ...mapState({
        tableData: state => state.tableData[state.tableSource],
        loading: state => state.tableData[state.tableSource].loading,
        sepas: state => state.tableData[state.tableSource].rows,
        tableSource: state => state.tableSource
      }),
      extraData() {
        return {
          tableName: `${SEPA_TABLE_NAME}}.${this.tableSource}`,
        }
      },
    },
    methods: {
      ...mapActions([
        'getTableData',
        'removeSepa'
      ]),
      async download(sepa, type) {
        const {response, success} = await sepaService.getDownloadUrl(sepa, type);
        if (!success) {
          this.$errorDialog(response.data.error, i18n.t('Error'));
          return;
        }
        if (type === 'xml') {
          fetch(response.data.url)
              .then(response => response.text())
              .then(data => {
                const xmlBlob = new Blob([data], {type: 'text/xml'});
                const downloadLink = document.createElement("a");
                downloadLink.download = `sepa.xml`;
                downloadLink.href = URL.createObjectURL(xmlBlob);
                downloadLink.click();
          });
        } else {
          window.open(response.data.url, '_blank');
        }
      },
      async onRemoveClick(item) {
        this.$confirm(
          this.$i18n.t("Are you sure you want to delete following SEPA?"),
          this.$i18n.t('SEPA was successfully deleted'),
          this.removeSepa,
          item
        );
      },
    },
    mounted() {
      this.getTableData();
    },
  }
</script>

<style lang="scss" scoped>
  @import "./scss/variables";

  .artisio-table {
    /deep/ {
      
    }
  }
</style>
